import * as React from 'react';

import { Styled } from './headline.styles';
import type { HeadlineProps } from './headline.types';

export const Headline = React.forwardRef<HTMLHeadingElement, HeadlineProps>(
  (
    {
      children,
      className,
      ellipsis,
      noMargin,
      size = 'medium',
      sizeConfined,
      sizeWide,
      ...props
    },
    forwardedRef
  ): JSX.Element => (
    <Styled.Headline
      $ellipsis={ellipsis}
      $noMargin={noMargin}
      $size={size}
      $sizeConfined={sizeConfined}
      $sizeWide={sizeWide}
      className={className}
      data-xds="Headline"
      ref={forwardedRef}
      {...props}
    >
      {children}
    </Styled.Headline>
  )
);

Headline.displayName = 'Headline';
